<ion-app>
    <ion-router-outlet></ion-router-outlet>
    <web-loader
        [show]="!!loadingData"
        [absolute]="true"
        [fullHeight]="loadingData?.fullHeight || false"
        [message]="loadingData?.message"
    ></web-loader>
    <ion-alert
        mode="ios"
        [isOpen]="isUpdateAlertOpen"
        header="{{ 'COMPONENTS.UPDATE_ALERT.TITLE' | translate }}"
        [buttons]="alertButtons"
        message="{{
            'COMPONENTS.UPDATE_ALERT.CONTENT'
                | translate: { available: this.availableAppVersion, current: this.currentAppVersion }
        }}"
        (didDismiss)="showAlert(false)"
    ></ion-alert>
</ion-app>
